import { Modal as ModalModule, UI, Utils } from 'common';
import PropTypes from 'prop-types';
import React from 'react';
import InsuranceClaimForm from './InsuranceClaimForm.component';

const { Session, Validation, Analytics } = Utils;
const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const {
	WrappedDropdownWithLabel,
	WrappedInputTextWithLabel,
	WrappedButton,
	WrappedButtonType,
} = UI;

class InsuranceClaimFormModal extends React.Component {
	constructor(props) {
		super(props);

		const {
			data: { print = {}, address = {} },
		} = props;

		this.state = {
			packageRecipientsName: '',
			dateMailed: props.data.dateMailed,
			customerId: props.data.customerId,
			insuranceId: print.trackingNumber,
			claimType: 'Loss',
			description: '',
			amountOfClaim: '',
			lessSalvageValue: '',
			amountPaidByUSPS: '',
			name: address.name,
			address: address.addressLine1,
			city: address.city,
			state: address.stateProvince,
			zip: address.postalCode,
			telephone: address.phone,
			email: props.data.email,
			validationErrors: {
				// 0 = untouched, -1 = failed, 1 = valid
				packageRecipientsName: 0,
				description: 0,
				amountOfClaim: 0,
				lessSalvageValue: 0,
				amountPaidByUSPS: 0,
				name: 0,
				address: 0,
				city: 0,
				state: 0,
				zip: 0,
				telephone: 0,
				email: 0,
			},
			wasSubmitSuccessful: false,
		};
	}

	getDataForPrint = () => {
		const {
			packageRecipientsName,
			dateMailed,
			customerId,
			insuranceId,
			claimType,
			description,
			amountOfClaim,
			amountPaidByUSPS,
			lessSalvageValue,
			name,
			address,
			city,
			state,
			zip,
			telephone,
			email,
		} = this.state;
		return {
			packageRecipientsName,
			dateMailed,
			customerId,
			insuranceId,
			claimType,
			description,
			amountOfClaim,
			amountPaidByUSPS,
			lessSalvageValue,
			pip_owes:
				parseFloat(amountOfClaim - amountPaidByUSPS - lessSalvageValue)
					.toFixed(2)
					.toString()
					.padStart(5, '0') || '0.00',
			name,
			name2: name, // ???
			address,
			city,
			state,
			zip,
			telephone,
			email,
		};
	};

	onBlur = ({ target: { name, value } }) => {
		const { validationErrors } = this.state;

		this.setState({
			validationErrors: {
				...validationErrors,
				[name]: value.length === 0 ? -1 : 1,
			},
		});
		if (
			value.includes('.') &&
			value.length > 1 &&
			(name === 'amountOfClaim' ||
				name === 'lessSalvageValue' ||
				name === 'amountPaidByUSPS')
		) {
			this.setState({
				[name]: parseFloat(value).toFixed(2),
			});
		}
	};

	onChange = e => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	};

	showCustomError = description => {
		const { showError } = this.context;

		showError({
			data: {
				description,
				title: 'Error',
				primaryButtonText: 'Ok',
				handleType: 'custom',
			},
		});
	};

	/**
	 * Validate the claim form data.
	 * @returns {boolean} `true` when all required fields are valid.
	 */
	isClaimFormValid = () => {
		const {
			data: { print = {} },
		} = this.props;
		const { insuredValue = 0 } = print;
		const {
			amountOfClaim,
			lessSalvageValue,
			amountPaidByUSPS,
			validationErrors,
		} = this.state;

		const claimAmount = Number(amountOfClaim);
		const salvageAndUSPSAmount =
			Number(lessSalvageValue) + Number(amountPaidByUSPS);

		const isClaimAmountValid = claimAmount <= insuredValue;
		const isNetClaimAmountValid = claimAmount - salvageAndUSPSAmount > 0;
		const isSalvageAndUSPSAmountValid = salvageAndUSPSAmount <= claimAmount;

		// validate form if there're empty fields
		const newValidationErrors = Object.keys(validationErrors).reduce(
			(_newValidationErrors, key) => {
				const { [key]: val } = this.state;

				_newValidationErrors[key] = val === 0 || val === '' ? -1 : 1;

				return _newValidationErrors;
			},
			{}
		);

		const areRequiredFieldsFilled = Object.values(newValidationErrors).every(
			val => val === 1
		);

		this.setState(
			{
				validationErrors: newValidationErrors,
			},
			() => {
				if (!areRequiredFieldsFilled) {
					return;
				}

				if (!isClaimAmountValid) {
					this.showCustomError(
						'Your claim amount is more than your insured amount.'
					);
				} else if (!isNetClaimAmountValid) {
					this.showCustomError(
						'[Claim amount - (Salvage Amount + USPS Amount)] has to be greater than $0.00.'
					);
				} else if (!isSalvageAndUSPSAmountValid) {
					this.showCustomError(
						'(Salvage Amount + USPS Amount) must not be greater than Claim Amount.'
					);
				}
			}
		);

		return (
			areRequiredFieldsFilled &&
			isClaimAmountValid &&
			isNetClaimAmountValid &&
			isSalvageAndUSPSAmountValid
		);
	};

	onDoneClick = () => {
		const { modalId } = this.props;
		const { closeModal } = this.context;

		closeModal(modalId);
	};

	onSubmit = () => {
		const { wasSubmitSuccessful } = this.state;
		const { showModal } = this.context;
		const printData = this.getDataForPrint();
		const showInduranceClaimForm = () => {
			showModal({
				component: InsuranceClaimForm,
				data: printData,
			});
		};

		if (wasSubmitSuccessful) {
			showInduranceClaimForm();
		} else if (this.isClaimFormValid()) {
			Analytics.trackEvent(
				'fileInsuranceClaim',
				{
					insurance_type: 'Stamps',
					claim_type: printData.claimType,
					amount: printData.amountOfClaim,
				},
				Analytics.agent.segment
			);
			showInduranceClaimForm();
			this.setState({ wasSubmitSuccessful: true });
		}
	};

	renderPostFileClaimView = () => (
		<div className="post-file-claim-view">
			<p>
				<strong>Insurance Claim Instructions</strong>
			</p>
			<p>
				To complete your claim, simply print, sign and mail the claim form with
				all required items to the address listed on the claim form. It may take
				2-3 weeks for processing to complete, at which time you will be notified
				by email.
			</p>

			<strong>Important Notes</strong>
			<p>
				Please do not submit claims for lost packages before 30 days after the
				shipment date. Claims for Damage can be submitted at any time. All
				claims must be submitted within 90 days after the shipment date.
			</p>
			<p>
				The package recipient should hold damaged items in the event they are
				requested during claims processing. FAILURE TO RETAIN DAMAGED PROPERTY
				COULD AFFECT FINAL SETTLEMENT OF THE CLAIM.
			</p>
			<p>
				Warning: Any fraudulent claims will make the shipper and/or package
				recipient liable for prosecution for mail fraud under the Federal
				Criminal Code.
			</p>
			<p>
				Please contact PIP directly if you have not received a response to your
				claim within three weeks:{' '}
				<a
					href="http://www.pipinsure.com/contact.aspx"
					target="_blank"
					rel="noopener noreferrer"
				>
					http://www.pipinsure.com/contact.aspx
				</a>
			</p>
			<div className="claim-form-footer">
				<WrappedButton
					className="submit-btn"
					onClick={this.onSubmit}
					label="Re-Print Form"
					dataqa="insurance-claim-form-reprint"
				/>
				<WrappedButton
					buttonType={WrappedButtonType.Primary}
					onClick={this.onDoneClick}
					label="Done"
					dataqa="insurance-claim-done"
				/>
			</div>
		</div>
	);

	renderFileClaimView = () => {
		const {
			packageRecipientsName,
			dateMailed,
			customerId,
			insuranceId,
			claimType,
			description,
			amountOfClaim,
			lessSalvageValue,
			amountPaidByUSPS,
			name,
			address,
			city,
			state,
			zip,
			telephone,
			email,
			validationErrors,
		} = this.state;

		return (
			<div>
				<div className="file-claim-view">
					<p>
						<b>Claim Form Information</b>
					</p>
					<WrappedInputTextWithLabel
						label="Package Recipient's Name:"
						className="inputtext"
						isInputInvalid={validationErrors.packageRecipientsName === -1}
						errorMessage="Recipient name is required."
						uiElementConfig={{
							autoFocus: true,
							type: 'text',
							name: 'packageRecipientsName',
							value: packageRecipientsName,
							required: true,
							dataqa: 'recipients-name',
							onChange: this.onChange,
							onBlur: this.onBlur,
						}}
					/>
					<WrappedInputTextWithLabel
						label="Date Mailed:"
						className="inputtext"
						uiElementConfig={{
							type: 'text',
							name: 'dateMailed',
							value: dateMailed,
							dataqa: 'date-mailed',
							readOnly: true,
						}}
					/>
					<WrappedInputTextWithLabel
						label="Your Customer ID:"
						className="inputtext"
						uiElementConfig={{
							type: 'text',
							name: 'customerId',
							value: customerId,
							dataqa: 'customer-id',
							readOnly: true,
						}}
					/>
					<WrappedInputTextWithLabel
						label={'Stamps.com Insurance ID/Tracking #:'}
						className="inputtext"
						uiElementConfig={{
							type: 'text',
							name: 'insuranceId',
							value: insuranceId,
							dataqa: 'customer-id',
							readOnly: true,
						}}
					/>
					<WrappedDropdownWithLabel
						label="Claim Type:"
						className="inputtext"
						uiElementConfig={{
							optionLabel: '',
							options: ['Loss', 'Damage', 'Shortage'],
							name: 'claimType',
							value: claimType,
							dataqa: 'claim-type',
							onChange: this.onChange,
						}}
					/>
					<WrappedInputTextWithLabel
						label="Description of items:"
						className="inputtext"
						isInputInvalid={validationErrors.description === -1}
						errorMessage="Description is required."
						uiElementConfig={{
							type: 'text',
							name: 'description',
							value: description,
							required: true,
							dataqa: 'description',
							onChange: this.onChange,
							onBlur: this.onBlur,
						}}
					/>
					<WrappedInputTextWithLabel
						label="Amount of Claim:$"
						className="inputtext"
						isInputInvalid={validationErrors.amountOfClaim === -1}
						errorMessage="Please enter a valid amount."
						uiElementConfig={{
							name: 'amountOfClaim',
							value: amountOfClaim,
							valuefromstate: amountOfClaim,
							chartoaccept: 46,
							required: true,
							dataqa: 'amount-of-claim',
							onChange: this.onChange,
							onBlur: this.onBlur,
							onKeyPress: Validation.validateInputForCurrency,
						}}
					/>
				</div>
				<p className="span-columns">
					Invoice or repair cost of contents lost or damaged, excluding shipping
					fees: (Amount cannot exceed the value declared upon shipment.)
				</p>
				<div className="file-claim-view">
					<WrappedInputTextWithLabel
						label="Less Salvage value:-$"
						className="inputtext"
						isInputInvalid={validationErrors.lessSalvageValue === -1}
						errorMessage="Please enter an amount."
						uiElementConfig={{
							type: 'text',
							name: 'lessSalvageValue',
							value: lessSalvageValue,
							valuefromstate: lessSalvageValue,
							chartoaccept: 46,
							required: true,
							dataqa: 'less-salvage-value',
							onChange: this.onChange,
							onBlur: this.onBlur,
							onKeyPress: Validation.validateInputForCurrency,
						}}
					/>
					<WrappedInputTextWithLabel
						label="Amount Paid by USPS:-$"
						className="inputtext"
						isInputInvalid={validationErrors.amountPaidByUSPS === -1}
						errorMessage="Please enter an amount."
						uiElementConfig={{
							type: 'text',
							name: 'amountPaidByUSPS',
							value: amountPaidByUSPS,
							valuefromstate: amountPaidByUSPS,
							chartoaccept: 46,
							required: true,
							dataqa: 'amount-paid-by-usps',
							onChange: this.onChange,
							onBlur: this.onBlur,
							onKeyPress: Validation.validateInputForCurrency,
						}}
					/>
					<p>
						<b>Your Contact Information For a Refund</b>
					</p>
					<WrappedInputTextWithLabel
						label="Name:"
						className="inputtext"
						isInputInvalid={validationErrors.name === -1}
						errorMessage="Name is required."
						uiElementConfig={{
							type: 'text',
							name: 'name',
							value: name,
							required: true,
							dataqa: 'name',
							onChange: this.onChange,
							onBlur: this.onBlur,
						}}
					/>
					<WrappedInputTextWithLabel
						label="Mailing Address:"
						className="inputtext"
						isInputInvalid={validationErrors.address === -1}
						errorMessage="Mailing Address is required."
						uiElementConfig={{
							type: 'text',
							name: 'address',
							value: address,
							required: true,
							dataqa: 'address',
							onChange: this.onChange,
							onBlur: this.onBlur,
						}}
					/>
					<WrappedInputTextWithLabel
						label="City:"
						className="inputtext"
						isInputInvalid={validationErrors.city === -1}
						errorMessage="City is required."
						uiElementConfig={{
							type: 'text',
							name: 'city',
							value: city,
							required: true,
							dataqa: 'city',
							onChange: this.onChange,
							onBlur: this.onBlur,
						}}
					/>
					<WrappedInputTextWithLabel
						label="State:"
						className="inputtext"
						isInputInvalid={validationErrors.state === -1}
						errorMessage="State is required."
						uiElementConfig={{
							type: 'text',
							name: 'state',
							value: state,
							required: true,
							dataqa: 'state',
							onChange: this.onChange,
							onBlur: this.onBlur,
						}}
					/>
					<WrappedInputTextWithLabel
						label="Zip:"
						className="inputtext"
						isInputInvalid={validationErrors.zip === -1}
						errorMessage="Zip is required."
						uiElementConfig={{
							type: 'text',
							name: 'zip',
							value: zip,
							required: true,
							dataqa: 'zip',
							onChange: this.onChange,
							onBlur: this.onBlur,
						}}
					/>
					<WrappedInputTextWithLabel
						label="Telephone:"
						className="inputtext"
						isInputInvalid={validationErrors.telephone === -1}
						errorMessage="Telephone is required."
						uiElementConfig={{
							type: 'text',
							name: 'telephone',
							value: telephone,
							required: true,
							dataqa: 'telephone',
							onChange: this.onChange,
							onBlur: this.onBlur,
						}}
					/>
					<WrappedInputTextWithLabel
						label="E-mail:"
						className="inputtext"
						isInputInvalid={validationErrors.email === -1}
						errorMessage="E-mail is required."
						uiElementConfig={{
							type: 'text',
							name: 'email',
							value: email,
							required: true,
							dataqa: 'email',
							onChange: this.onChange,
							onBlur: this.onBlur,
						}}
					/>
				</div>
			</div>
		);
	};

	render() {
		const { wasSubmitSuccessful } = this.state;
		const { modalId } = this.props;

		const primaryButton = {
			type: ModalButtonActionType.Confirm,
			text: 'Print Form',
			onClick: this.onSubmit,
			dataqa: 'insurance-claim-form-print-form-button',
		};

		const secondaryButton = {
			type: ModalButtonActionType.Cancel,
			text: 'Cancel',
			dataqa: 'insurance-claim-form-cancel-button',
		};

		return (
			<Modal
				modalId={modalId}
				className="history-claim-form insurance-claim-form-modal"
				header="Insurance Claim Form"
				primaryButton={primaryButton}
				secondaryButton={secondaryButton}
				hideFooter={wasSubmitSuccessful}
				size="large"
			>
				{wasSubmitSuccessful
					? this.renderPostFileClaimView()
					: this.renderFileClaimView()}
			</Modal>
		);
	}
}

InsuranceClaimFormModal.propTypes = {
	data: PropTypes.shape({
		print: PropTypes.object,
	}),
};

InsuranceClaimFormModal.contextType = ModalContext;

export default InsuranceClaimFormModal;
